module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-6.d9c6e6e8.png";